import React from "react";
import { css } from "@linaria/core";
import formatNumber from "@ui/i18n/formatNumber";
import { color, fonts } from "@ui";
import AlertIcon from "./AlertIcon";
import type { AlertType } from "./useQuantityAlerts";

function AlertBadge({
  withIcon,
  alertPercentage,
  alertType = "measures",
}: {
  withIcon: boolean;
  alertPercentage: number;
  alertType?: AlertType;
}) {
  const formattedPercentage =
    alertPercentage > 0.5
      ? formatNumber(alertPercentage, {
          precision: 0,
        })
      : "<1";
  return (
    <div className={alertBadgeCss}>
      {withIcon ? <AlertIcon alertType={alertType} /> : null}
      {alertPercentage === 0 ? null : (
        <div className={alertPercentageCss}>{`[${formattedPercentage}%]`}</div>
      )}
    </div>
  );
}

const alertBadgeCss = css`
  display: flex;
  align-items: center;
`;

const alertPercentageCss = css`
  :not(:first-child) {
    margin-left: 5px;
  }
  font: ${fonts.body2SemiBold};
  color: ${color.darkNitrogen500};
`;

export default AlertBadge;
